/**
NPR variant resolver -
Maps (requestTypeId + effective formVersion) → NPR variant family.
Used by the form registry so drafts load the latest variant and non-drafts
rehydrate the variant/version they were submitted with.
 */

import { RequestTypeIds } from '@src/utils/enums';
import type { NprVariant } from './nprConfig';

type Rule = { minVersion: number; variant: NprVariant };

/** IMPORTANT: The `variant` values returned here MUST exist in nprConfig.ts:
- If we return `abNprV3`, nprConfig must include `abNprV3@<version>` entries.
 */
const nprVariantRulesByRequest: Partial<Record<number, Rule[]>> = {
  [RequestTypeIds.NoPermitRequired]: [{ minVersion: 1, variant: 'npr' }],
  [RequestTypeIds.ActivityBasedNoPermitRequired]: [
    { minVersion: 3, variant: 'abNpr' }, // if needed - new variant starting in v2+
    { minVersion: 1, variant: 'abNpr' },
  ],
};

export const resolveNprVariant = ({ requestTypeId, version }: { requestTypeId: number; version: number }) => {
  const rules = nprVariantRulesByRequest[requestTypeId] ?? [];

  return rules
    .slice()
    .sort((a, b) => b.minVersion - a.minVersion)
    .find((r) => version >= r.minVersion)?.variant;
};
